import { render } from "./inputValidateNotes.vue?vue&type=template&id=471abdbf&scoped=true&lang=pug"
import script from "./inputValidateNotes.vue?vue&type=script&lang=js"
export * from "./inputValidateNotes.vue?vue&type=script&lang=js"

import "./inputValidateNotes.vue?vue&type=style&index=0&id=471abdbf&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-471abdbf"]])

export default __exports__